





































import { Component, Prop, Vue } from "vue-property-decorator";
import { FolderEntry, Breadcrumb } from "@/models/file";
import { Folder } from "@/api/report-api";
import {
  getDocumentEntries,
  saveDocumentEntry,
  deleteDocumentEntry,
  readDocumentEntry
} from "@/api/document-api";
import download from "@/helpers/download";
import UploadFileProject from "@/models/specs/UploadFileProject";

import FileExplorer from "@/templates/FileExplorer.vue";
import VPreview, { PreviewAction } from "../components/VPreview.vue";
import NewFolderModal from "../components/NewFolderModal.vue";
import NewFolderRequest from "@/models/new-folder-request";

@Component({
  components: {
    VPreview,
    FileExplorer,
    NewFolderModal
  }
})
export default class ProjectDocumentPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  currentFolderId: any = "0";
  entries: FolderEntry[] = [];
  path: Breadcrumb[] = [];
  currentFolder: Folder | null = null;
  selectedDocument: FolderEntry | null = null;
  allowExtensions: string = "*";

  newFolderRequest = new NewFolderRequest();

  selectedDocumentUrl: string = "";

  showNewFolderModal() {
    this.newFolderRequest = new NewFolderRequest();
    this.newFolderRequest.name = "新しいフォルダ";
    this.newFolderRequest.projectId = this.projectId;
    this.newFolderRequest.parentFolderId = this.currentFolderId;
  }

  get previewActions(): PreviewAction[] {
    if (!this.selectedDocument) return [];
    this.selectedDocumentUrl =
      this.selectedDocument.image + "#toolbar=0&amp;navpanes=0&amp;view=FitV";
    const actions = [];
    if (this.canWriteDocument()) {
      actions.push(this.createDeleteAction());
    }
    actions.push(this.createDownloadAction());
    return actions;
  }

  download() {
    if (!this.selectedDocument) return;
    download(this.selectedDocument.image, this.selectedDocument.name);
  }

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  canWriteDocument() {
    return (
      this.permissions.includes("service/project_operation") ||
      this.permissions.includes("project/document_secret") ||
      (this.permissions.includes("project/task_operation") &&
        this.permissions.includes("service/master_read") &&
        this.permissions.includes("project/document_operation"))
    );
  }

  created() {
    this.initEntries();
  }
  uploadDocumentFiles(files: FileList) {
    // console.log("Upload Files: ", files);
    if (!files.length) return;
    Array.from(files).forEach(uploadFile => {
      this.uploadDocument(uploadFile);
    });
  }
  async uploadDocument(uploadFile: File) {
    // console.log("Upload File: ", uploadFile);
    const spec = new UploadFileProject();
    if (!spec.isSatisfied(uploadFile)) {
      alert(spec.errors);
      return;
    }
    const data = new FormData();
    data.append("projectId", this.projectId);
    data.append("parentFolderId", this.currentFolderId);
    data.append("kind", "file");
    data.append("image", uploadFile);
    await saveDocumentEntry(data);
    this.initEntries();
  }

  async removeSelectedDocument() {
    if (!this.selectedDocument) return;
    this.remove(this.selectedDocument);
    this.selectedDocument = null;
  }

  /* ここから下はほぼFileExplorerで共通 */

  async initEntries() {
    const { entries, path } = await getDocumentEntries(
      this.projectId,
      this.currentFolderId
    );
    this.entries = entries;
    this.path = path;
  }

  open(entry: FolderEntry, _index: number) {
    switch (entry.kind) {
      case "folder":
        this.changeCurrentFolder(entry.entryId);
        break;
      case "file":
        this.selectedDocument = entry;
        readDocumentEntry(entry.entryId);
        (this.$refs.preview as VPreview).show();
        this.initEntries();
        break;
    }
  }

  changeCurrentFolder(id: any) {
    this.currentFolderId = id;
    this.initEntries();
  }

  async addFolder() {
    await saveDocumentEntry(this.newFolderRequest.toFormData());
    await this.initEntries();
  }

  async mv(id: any, folderId: any) {
    const entry = this.entries.find(e => String(e.entryId) === id);
    if (!entry) return;
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", entry.name);
    data.append("kind", entry.kind);
    data.append("projectId", this.projectId);
    data.append("parentFolderId", folderId);
    await saveDocumentEntry(data);
    this.initEntries();
  }

  async rename(entry: FolderEntry, name: string) {
    const data = new FormData();
    data.append("id", String(entry.entryId));
    data.append("name", name);
    data.append("kind", entry.kind);
    data.append("projectId", this.projectId);
    data.append("parentFolderId", this.currentFolderId);
    await saveDocumentEntry(data);
    this.initEntries();
  }

  async remove(entry: FolderEntry) {
    await deleteDocumentEntry(entry.entryId);
    await this.initEntries();
  }

  private createDeleteAction(): PreviewAction {
    return {
      key: "delete",
      icon: "trash",
      title: "削除",
      variant: "secondary",
      click: () => {
        const confirmed = confirm("本当に削除してもよろしいですか？");
        if (!confirmed) return;
        this.removeSelectedDocument();
        (this.$refs.preview as VPreview).hide();
      }
    };
  }

  private createDownloadAction(): PreviewAction {
    return {
      key: "download",
      icon: "download",
      title: "ダウンロード",
      variant: "secondary",
      click: () => {
        this.download();
      }
    };
  }
}
